export default __webpack_public_path__ + "static/media/login_header.aa3051e4.jpg";